import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, tap, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';

export enum CompanyComponentEnum {
  OVERVIEW_STATUS_DISTRIBUTION = 1,
  OVERVIEW_G_SCORE_DISTRIBUTION = 2,
  OVERVIEW_CLOSE_REASON_DISTRIBUTION = 3,
  OVERVIEW_STATUS_HISTORY = 4,
  CANDIDATE_DASHBOARD_G_SCORE = 5,
  SHOW_GENERAL_B_SCORE = 6,
  CANDIDATE_DASHBOARD_TOP_COMPETENCIES = 7,
  CANDIDATE_DASHBOARD_INTERESTS = 8,
  CANDIDATE_DASHBOARD_BALANCE = 9,
  CANDIDATE_DASHBOARD_LOCUS_OF_CONTROL = 10,
  PROFILES_GRID_SHOW_REHA = 11,
  CANDIDATE_GRID_SHOW_G_SCORE = 12,
  CANDIDATE_GRID_SHOW_SELFREGISTRATION = 13,
  CANDIDATE_GRID_SHOW_IAS = 14,
  CANDIDATE_GRID_SHOW_PROGNOSE = 15,
}

@Injectable({
  providedIn: 'root',
})
export class CompanyComponentsService {
  private apiUrl = environment.apiUrl;
  private componentsSignal = signal<CompanyComponentEnum[]>([]);
  private currentCompanyId: number | null = null;
  private componentsObservable$: Observable<CompanyComponentEnum[]> | null =
    null;

  constructor(private http: HttpClient) {}

  getCompanyComponents(companyId: number): Observable<CompanyComponentEnum[]> {
    // If we're already fetching components for this company, return the existing observable
    if (this.currentCompanyId === companyId && this.componentsObservable$) {
      return this.componentsObservable$;
    }

    // Reset and create new observable for different company
    this.currentCompanyId = companyId;
    this.componentsObservable$ = this.http
      .get<
        number[]
      >(`${this.apiUrl}api/Customer/GetCompanyComponents?companyId=${companyId}`)
      .pipe(
        map((response) => response.map((key) => key as CompanyComponentEnum)),
        tap((components) => {
          this.componentsSignal.set(components);
        }),
        shareReplay(1),
      );

    return this.componentsObservable$;
  }

  getComponentsSignal() {
    return this.componentsSignal.asReadonly();
  }

  resetComponentsObservable() {
    this.componentsObservable$ = null;
    this.currentCompanyId = null;
    this.componentsSignal.set([]);
  }
}
